export default __webpack_public_path__ + "static/media/logo.ffad5c4f.svg";